/* ==========================================================================
   Bumberry — Our Story
   Section behaviour. Pure JS, no dependencies. Load from the theme with:
     <script src="{{ 'section-our-story.js' | asset_url }}" defer></script>
   All presentation lives in section-our-story.css; this file only toggles
   classes and swaps the panel's text/image content.
   ========================================================================== */
(function () {
  'use strict';

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var btn = document.querySelector('[data-drawer-toggle]');
    var drawer = document.querySelector('[data-drawer]');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ---------- directional reveals ---------- */
  function initReveals() {
    var targets = document.querySelectorAll('[data-reveal]');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    targets.forEach(function (el) {
      var sibs = Array.prototype.filter.call(el.parentElement.children, function (c) {
        return c.hasAttribute('data-reveal');
      });
      el.style.transitionDelay = (Math.max(0, sibs.indexOf(el)) * 0.09) + 's';
      io.observe(el);
    });
  }

  /* ---------- timeline: spine fills, rows rise, nodes light up ---------- */
  function initTimeline() {
    var fill = document.getElementById('tlFill');
    var spine = document.querySelector('.tl-spine');
    var rows = Array.prototype.slice.call(document.querySelectorAll('.tl-row'));
    if (!fill || !spine || !rows.length) return;

    function onScroll() {
      var r = spine.getBoundingClientRect();
      var mid = window.innerHeight * 0.62;
      var p = Math.max(0, Math.min(1, (mid - r.top) / r.height));
      fill.style.height = (p * 100).toFixed(2) + '%';

      rows.forEach(function (row) {
        if (row.classList.contains('is-in')) return;
        if (row.getBoundingClientRect().top < window.innerHeight * 0.82) row.classList.add('is-in');
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  /* ---------- interactive process pipeline ---------- */
  var STEPS = [
    {
      title: 'R&D and Designing',
      copy: 'Every fit starts on our own table. We prototype, test on real babies across Indian climates, and only then commit a pattern to production.',
      image: 'assets/cotton-layers.png'
    },
    {
      title: 'Raw materials Procurement',
      copy: 'We craft customised fabrics rather than buying off the shelf, so we can guarantee the cotton touching your baby is exactly what we specified.',
      image: 'assets/scene-cotton.png'
    },
    {
      title: 'In-house Production',
      copy: 'Cutting, stitching and assembly all happen on our own floor in Kochi, by tailors we employ directly. Nothing is white-labelled.',
      image: 'assets/scene-sewing.png'
    },
    {
      title: 'Quality Checking',
      copy: 'Every diaper is checked by a person before it is packed, for absorbency, snap strength and stitch integrity. Anything short of the mark never leaves.',
      image: 'assets/pdp-cotton-core.png'
    },
    {
      title: 'Packing & Shipping',
      copy: 'We pack and dispatch ourselves, so orders leave Kochi within two working days and arrive exactly as we intended them to.',
      image: 'assets/smart-nappy-pile.png'
    }
  ];

  function initProcess() {
    var wrap = document.getElementById('process');
    if (!wrap) return;
    var steps = Array.prototype.slice.call(wrap.querySelectorAll('.pipe-step'));
    var railFill = wrap.querySelector('.pipe-rail-fill');
    var img = document.getElementById('stepImg');
    var elTitle = document.getElementById('stepTitle');
    var elCopy = document.getElementById('stepCopy');
    var elCount = document.getElementById('stepCount');
    if (!steps.length) return;

    var current = 0;
    var timer = null;
    var touched = false;

    function render(i) {
      var n = STEPS.length;
      current = ((i % n) + n) % n;
      var s = STEPS[current];
      steps.forEach(function (el, idx) { el.classList.toggle('is-active', idx === current); });
      if (railFill) railFill.style.width = ((current / (n - 1)) * 80) + '%';
      if (img) { img.src = s.image; img.alt = s.title; }
      if (elTitle) elTitle.textContent = s.title;
      if (elCopy) elCopy.textContent = s.copy;
      if (elCount) elCount.textContent = 'Step ' + (current + 1) + ' of ' + n;
    }

    function takeOver() {
      touched = true;
      if (timer) { clearInterval(timer); timer = null; }
    }

    steps.forEach(function (el, idx) {
      el.addEventListener('click', function () { takeOver(); render(idx); });
    });
    var prev = wrap.querySelector('[data-step-prev]');
    var next = wrap.querySelector('[data-step-next]');
    if (prev) prev.addEventListener('click', function () { takeOver(); render(current - 1); });
    if (next) next.addEventListener('click', function () { takeOver(); render(current + 1); });

    // auto-advance once in view, until the visitor takes over
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && !timer && !touched) {
            timer = setInterval(function () {
              if (touched) return;
              render(current + 1);
            }, 3600);
          }
        });
      }, { threshold: 0.35 });
      io.observe(wrap);
    }

    render(0);
  }

  function boot() {
    initDrawer();
    initReveals();
    initTimeline();
    initProcess();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();